// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__tum8W","card":"page_card__lRdAS","cardContainer":"page_cardContainer__CxAvs"};